<template>

<com-item name="game.affinity.people" :size="size" :loading="loading" :is-empty="!active" :has-more="hasMore" v-on:more="onMore" title="Designers & Publishers">

	<template v-slot:about>

		<p>{{ your | capitalise }} history with the people behind this game.</p>

	</template>

	<template v-slot:stats>

		<com-affinity-list v-if="active" :items="items" :baselines="data.baselines" :your="your" :you="you" v-on:select="onSelect" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comAffinityList from './AffinityList'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-affinity-list': comAffinityList
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/affinity'] },

		items: function() {

			if (!this.data || !this.data.attributes) return []
			return this.data.attributes.filter(function(a) { return a.type === 'designer' || a.type === 'publisher' })

		},

		total: function() {

			if (!this.data || !this.data.totals) return 0
			return (this.data.totals.designer || 0) + (this.data.totals.publisher || 0)

		},

		hasMore: function() { return this.total > 5 },

		active: function() { return !this.loading && this.items.length }

	},

	methods: {

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityPeople',
				id: parseInt(this.$route.params.game) || 0
			})

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: parseInt(this.$route.params.game) || 0,
				attrType: item.type,
				attrId: item.id
			})

		}

	}

}

</script>
